import storage from "store";
import expirePlugin from "store/plugins/expire";
import {getLoginUserInfo, loginByTicket, logout} from "@/api/sso";
import {
  ACCESS_TOKEN,
  TOKEN_NAME,
  USER_INFO,
  USER_DETAIL, TENANT,
} from "@/store/mutation-types";
import {getAppListV2, getCurrentNavigation, getLoginUserDetail} from "@/api/home";
import {generatorAppRouter, generatorNavigationRouter} from "@/router/generator-routers";
import { getLoginUserDetailInfo } from "@/api/contacts/contactsEmp";
import { getUnreadTotal } from "@/api/message";
import { listPlatformConfig } from '@/api/serviceHall/serviceHall'

storage.addPlugin(expirePlugin);
const user = {
  state: {
    token: "",
    name: "",
    avatar: "",
    info: {},
    detail: {
      homePage: "",
    },
    appList: [],
    navigationList: [],
    unreadMessageNum: undefined,
    platformConfig: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_INFO: (state, info) => {
      state.info = info;
    },
    SET_APP_LIST: (state, appList) => {
      state.appList = appList;
    },
    SET_NAVIGATION_LIST: (state, navigationList) => {
      state.navigationList = navigationList;
    },
    SET_UNREAD_MESSAGE_NUM: (state, unreadMessageNum) => {
      state.unreadMessageNum = unreadMessageNum;
    },
    SET_DETAIL: (state, detail) => {
      state.detail = detail;
    },
    SET_PLATFORM_CONFIG: (state, platformConfig) => {
      state.platformConfig = platformConfig
    },
  },

  actions: {
    LoginByTicket({ commit }, ticket) {
      return new Promise((resolve, reject) => {
        loginByTicket({ ticket: ticket }).then((response) => {
            if (response.success) {
              const result = response.data;
              storage.set(TOKEN_NAME, result.tokenName);
              storage.set(ACCESS_TOKEN, result.tokenValue, new Date().getTime() + result.tokenTimeout * 1000);
              commit("SET_TOKEN", result.tokenValue);
              storage.remove(USER_DETAIL);
              resolve(response);
            } else {
              reject(response);
            }
          }).catch((error) => {
            reject(error);
          });
      });
    },

    // 获取用户信息
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        // 请求后端获取用户信息 /api/user/info
        getLoginUserInfo()
          .then((response) => {
            const { data } = response;
            commit("SET_INFO", data);
            commit("SET_NAME", data.name);
            commit("SET_AVATAR", data.avatar);
            storage.set(USER_INFO, data);

            getLoginUserDetail()
              .then((res) => {
                const { data } = res;
                commit("SET_DETAIL", data);
                storage.set(USER_DETAIL, data);
                resolve(data);
              })
              .catch((error) => {
                reject(error);
              });
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 获取用户路由
    GetAppRouter({ commit }, router) {
      return new Promise((resolve, reject) => {
        getAppListV2()
          .then((response) => {
            const { data } = response;
            commit("SET_APP_LIST", data);
            const routerList = generatorAppRouter(data);
            // 下游
            resolve(routerList);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 获取用户路由
    GetNavigationRouter({ commit }, router) {
      return new Promise((resolve, reject) => {
        getCurrentNavigation()
          .then((response) => {
            const { data } = response;
            commit("SET_NAVIGATION_LIST", data);
            const routerList = generatorNavigationRouter(data);
            // 下游
            resolve(routerList);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 登出
    Logout({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token)
          .then(() => {
            resolve();
          })
          .catch((err) => {
            console.log("logout fail:", err);
            reject(err);
          })
          .finally(() => {
            commit("SET_TOKEN", "");
            storage.remove(ACCESS_TOKEN);
            storage.remove(TOKEN_NAME);
            storage.remove(USER_INFO);
            storage.remove(USER_DETAIL)
          });
      });
    },

    // 未读消息
    GetUnreadMessageNum({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUnreadTotal()
          .then((res) => {
            if (res.success) {
              commit("SET_UNREAD_MESSAGE_NUM", res.data);
              resolve();
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    // 获取平台配置
    async GetPlatFormConfig ({ commit }) {
      const response = await listPlatformConfig()
      try {
        if (response.success) {
          const platformConfig = response.data
          commit('SET_PLATFORM_CONFIG', platformConfig)
        }
      } catch (e) {
        console.log(e)
      }
    },
  },
};

export default user;
